/**
 * Created by Maxim B. on 20/05/20.
 * Copyright © 2020 SEVEN. All rights reserved.
 */
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'curr-icon-button',
  templateUrl: './icon-button.component.html',
  styleUrls: ['./icon-button.component.scss']
})
export class IconButtonComponent implements OnInit {

  @Input() icon = 'edit';
  @Input() disabled = false;

  constructor() { }

  ngOnInit(): void {
  }

}
